module.exports = __webpack_public_path__ + "img/sancamilo.ea8d0063.png";